<template>
  <v-container fluid>
    <v-card>
      <v-card-title>
        <span class="headline mb-0">保険費レート検索</span>
      </v-card-title>
      <v-card-actions>
        <v-btn @click="load" v-permit.SHARP_IR_SEARCH class="btn-search">{{$t('app.buttons.search')}}</v-btn>
        <v-btn to="/m0141/new" v-permit.SHARP_IR_NEW>{{$t('app.buttons.new')}}</v-btn>
        <v-btn
          :disabled="selected.length!==1"
          @click="edit"
          v-permit.SHARP_IR_EDIT.SHARP_IR_DETAIL
        >{{$t('app.buttons.edit')}}</v-btn>
        <v-btn
          :disabled="selected.length===0"
          @click="remove"
          v-permit.SHARP_IR_DELETE
        >{{$t('app.buttons.remove')}}</v-btn>
      </v-card-actions>
      <v-form>
        <v-container fluid>
          <v-layout row wrap>
            <v-flex md3 sm6 xs6>
              <remote-select label="運送形態" url="transport-modes/kv" v-model="query.transportModeId"></remote-select>
            </v-flex>
            <v-flex md3 sm6 xs6>
              <remote-select
                :label="$t('app.labels.incoterm')"
                item-text="code"
                url="incoterms/kv"
                v-model="query.incotermId"
              ></remote-select>
            </v-flex>
            <v-flex md3 sm6 xs12>
              <v-layout row wrap>
                <v-flex md6 pr-2 sm6 xs6>
                  <v-text-field label="レート From" v-model="query.rateFrom"></v-text-field>
                </v-flex>
                <v-flex md6 pl-2 sm6 xs6>
                  <v-text-field :min="query.rateFrom" label="レート To" v-model="query.rateTo"></v-text-field>
                </v-flex>
              </v-layout>
            </v-flex>
            <!--<v-text-field label="保険レート" v-model="query.insuranceRate"></v-text-field>-->
            <v-flex md3 sm6 xs6>
              <remote-autocomplete
                label="適用サプライヤー"
                url="companies/supplier"
                v-model="query.supplierId"
              ></remote-autocomplete>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex md3 sm6 xs6>
              <date-picker label="適用開始日" v-model="query.startDate"></date-picker>
            </v-flex>
            <v-flex md3 sm6 xs6>
              <date-picker :min="query.startDate" label="適用終了日" v-model="query.endDate"></date-picker>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>
    </v-card>
    <v-card class="mt-2">
      <v-card-title primary-title>
        <h3 class="headline mb-0">保険費レート</h3>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        class="elevation-0"
        item-key="id"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox hide-details primary v-model="props.selected"></v-checkbox>
          </td>
          <td>{{ props.item.transportModeCode }}</td>
          <td>{{ props.item.incotermCode }}</td>
          <td>{{ props.item.rate }}</td>
          <td>{{ props.item.startDate }}</td>
          <td>{{ props.item.endDate }}</td>
          <td>{{ props.item.supplierName ||'全体' }}</td>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
export default {
  components: {},
  data: () => ({
    loading: false,
    results: [],
    query: {},
    selected: [],
    headers: [
      { text: '運送形態', value: 'transportMode.code', sortable: false },
      { text: '適用建値', value: 'incoterm.code', sortable: false },
      { text: '保険レート', value: 'rate', sortable: false },
      { text: '適用開始日', value: 'startDate', sortable: false },
      { text: '適用終了日', value: 'endDate', sortable: false },
      { text: '適用サプライヤー', value: 'supplierName', sortable: false }
    ],
    pagination: {
      page: 1
    }
  }),
  methods: {
    load() {
      this.autoload = true
      this.$storeParams()
      this.loading = true
      this.$http
        .get('insurance-rates', {
          params: { ...this.query, ...this.$pageable() }
        })
        .then(res => {
          this.pagination.page = res.data.number + 1
          this.pagination.rowsPerPage = res.data.size
          this.pagination.totalItems = res.data.totalElements
          this.results = res.data.content
          this.loading = false
          this.selected = []
        })
    },
    edit() {
      this.$router.push({
        name: 'EditM0141',
        query: { id: this.selected[0].id }
      })
    },
    remove() {
      this.$confirm({ content: this.$t('app.messages.removeConfirm') }).then(
        () => {
          Promise.all(
            this.selected.map(s => {
              return this.$http.delete(`/insurance-rates/${s.id}`)
            })
          ).then(() => {
            this.load()
            this.selected = []
          })
        }
      )
    }
  },
  mounted() {
    this.$loadParams()
  },
  watch: {
    pagination() {
      if (this.autoload) this.load()
    }
  }
}
</script>